import { render, staticRenderFns } from "./ButtonFavourites.vue?vue&type=template&id=78442f20&"
import script from "./ButtonFavourites.vue?vue&type=script&lang=js&"
export * from "./ButtonFavourites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('78442f20', component.options)
    } else {
      api.reload('78442f20', component.options)
    }
    module.hot.accept("./ButtonFavourites.vue?vue&type=template&id=78442f20&", function () {
      api.rerender('78442f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/ButtonFavourites.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ButtonFavourites.vue
// module id = 4
// module chunks = 0 1 2 3 4 5 6 8